import * as Events from '@core/events';

export const handler = ({
  field,
  data,
}: Pick<Events.TEventInformation<unknown>, 'field' | 'data'>) => {
  field.data.keydown = true;
  field.value = data.parsedEventValue;
};
